import { Menu, Transition } from "@headlessui/react";
import { FaAngleDown } from "react-icons/fa";
import { Fragment } from "react/jsx-runtime";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useUsersHook } from "../../hooks/useUsersHook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { HiOutlineChevronDown } from "react-icons/hi2";

export default () => {
  const { UserOrgs } = useOrganizationHook();
  const { SelectedOrg, breadcrumbsTitle } = useStateGetter();
  const { setSelectedorg } = useStateSetter();

  return (
    <div className="font-medium text-sm mx-4 flex justify-center items-center  ">
      <p className="inline text-gray-500 font-medium">{breadcrumbsTitle}</p>
      <Menu as="div" className={`relative my-2     !inline `}>
        {SelectedOrg?.orgName && (
          <div className="inline">
            <Menu.Button className="  p-2    text-sm bg-white rounded-[8px]     !inline    ">
              <p className="cursor-pointer text-gray-400">
                /{SelectedOrg?.orgName}{" "}
                <HiOutlineChevronDown className="text-textbg inline " />{" "}
              </p>
            </Menu.Button>
          </div>
        )}
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white  max-h-[200px]  w-full overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none">
            {UserOrgs.map((item, key) => (
              <Menu.Item key={key}>
                {({ active }) => (
                  <p
                    onClick={() => {
                      setSelectedorg(item);
                    }}
                    className=" text-xs font-light w-full text-textbg p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    {item.orgName}
                  </p>
                )}
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
